import React from "react";

const values = [
  {
    k: "01",
    title: "Frisch & persönlich",
    body: "Wir sind ein junges Unternehmen – kurze Wege, direkter Draht zum Geschäftsführer, keine Hotline. Jedes Projekt wird von uns persönlich betreut.",
  },
  {
    k: "02",
    title: "Alles aus einer Hand",
    body: "Beratung, Planung, Installation, Inbetriebnahme, Förderanträge und Service. Ein einziger Ansprechpartner – von der ersten Idee bis viele Jahre nach der Montage.",
  },
  {
    k: "03",
    title: "Beratung",
    body: "Wir verkaufen nichts, was Sie nicht brauchen. Klare Wirtschaftlichkeits­rechnung, transparente Offerten, faire Preise – ohne versteckte Kosten.",
  },
];

const team = [
  {
    name: "Ramon Schaffner",
    role: "Geschäftsführer",
    initials: "RS",
    bio: "Treibt Solanova mit Branchenerfahrung und einer klaren Vision für effiziente, qualitativ hochwertige Solarlösungen in der Schweiz voran.",
  },
  {
    name: "Florian Rupp",
    role: "Projektleiter",
    initials: "FR",
    bio: "Verantwortet mit langjähriger Erfahrung Planung und Installation für technisch ausgereifte, wirtschaftliche und qualitativ hochwertige Solarlösungen.",
  },
];

export default function About() {
  return (
    <section
      id="ueber-uns"
      data-testid="about-section"
      className="section relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5">
            <p className="eyebrow" data-testid="about-eyebrow">Über uns</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-extralight tracking-tight mt-6 text-white leading-[1.05]">
              Sonnenenergie,
              <br />
              <span className="bronze-metallic">die zu Ihnen passt.</span>
            </h2>
          </div>

          <div className="lg:col-span-7 space-y-10">
            <p className="font-body text-lg md:text-xl text-white/70 leading-relaxed font-light">
              solanova gmbh ist ein junges Unternehmen mit Sitz in Wilen-Gottshaus.
              2026 von Ramon Schaffner gegründet,
              vereinen wir langjährige Erfahrung aus der Solarbranche mit dem
              Anspruch, Solar­lösungen wieder verständlich und persönlich zu
              machen.
            </p>
            <p className="font-body text-base md:text-lg text-white/55 leading-relaxed font-light">
              Wir planen und installieren Photovoltaik-Anlagen, Batteriespeicher
              und Wallboxen für Eigenheim­besitzer und Unternehmen in der gesamten
              Ost- und Zentralschweiz. Unsere Stärke ist die Kombination aus
              präziser Ingenieurs­arbeit und persönlicher Beratung – Anlagen, die
              heute liefern und in zwanzig Jahren noch wirtschaftlich sind.
            </p>

            <div className="grid sm:grid-cols-1 gap-px bg-white/5 rounded-2xl overflow-hidden mt-12">
              {values.map((v) => (
                <div
                  key={v.k}
                  data-testid={`about-value-${v.k}`}
                  className="bg-[var(--sol-surface)] p-8 md:p-10 flex gap-6 md:gap-10 group hover:bg-[var(--sol-surface-2)] transition-colors duration-500"
                >
                  <div className="font-display text-[var(--sol-bronze)] text-2xl font-light w-10 shrink-0">
                    {v.k}
                  </div>
                  <div>
                    <h3 className="font-display text-xl md:text-2xl text-white font-light mb-3">
                      {v.title}
                    </h3>
                    <p className="font-body text-sm md:text-base text-white/55 leading-relaxed">
                      {v.body}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Team */}
        <div className="mt-28 md:mt-36" id="team" data-testid="team-section">
          <div className="max-w-3xl">
            <p className="eyebrow">Team</p>
            <h3 className="font-display text-3xl md:text-4xl lg:text-5xl font-extralight tracking-tight mt-6 text-white leading-[1.1]">
              Die Köpfe hinter <span className="bronze-metallic">Solanova.</span>
            </h3>
          </div>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8 mt-12">
            {team.map((m) => (
              <article
                key={m.name}
                data-testid={`team-member-${m.initials}`}
                className="bg-[var(--sol-surface)] border border-white/8 hover:border-[var(--sol-bronze)]/40 rounded-3xl p-8 md:p-10 transition-all duration-500"
              >
                <div className="flex items-center gap-5">
                  <div
                    className="w-16 h-16 rounded-full flex items-center justify-center font-display text-xl"
                    style={{
                      background:
                        "linear-gradient(135deg, #E2C9A8 0%, #C8A27A 50%, #8B5E34 100%)",
                      color: "#0a0a0a",
                      fontWeight: 400,
                    }}
                  >
                    {m.initials}
                  </div>
                  <div>
                    <h4 className="font-display text-xl text-white font-light">
                      {m.name}
                    </h4>
                    <p className="text-[11px] uppercase tracking-[0.22em] text-[var(--sol-bronze)] mt-1 font-body">
                      {m.role}
                    </p>
                  </div>
                </div>
                <p className="font-body text-white/55 mt-6 leading-relaxed text-sm md:text-base">
                  {m.bio}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
